import '@start-base/react-consent-manager/styles.css';
import { ConsentProvider, ConsentBanner } from '@start-base/react-consent-manager';

export function Consent() {


  const consentOptions = {
    services: [
      {
        id: "necessary",
        name: "Necessary",
        description:
          "These are cookies that are necessary for our website to function. They include, for example, cookies that enable you to log into secure areas of our website or make use of our services, and to remember your cookie preferences.",
        scripts: [],
        mandatory: true,
      },
      {
        id: "analytics",
        name: "Analytics",
        description:
          "We use analytics cookies to help us understand how users discover and engage with our website, and it's loading performance accross devices, allowing us to improve and optimize the performance and user experience of our website.",
        scripts: [
          {
            "id": "gtm",
            src: "https://www.googletagmanager.com/gtag/js?id=GTM-K4XQH8C",
            async: true,
          },
          {
            "id": "gtm-init",
            code: `
              gtag('consent', 'update', {
                'analytics_storage': 'granted'
              });
            `
          },
          {
            id: "klaviyo",
            src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Rt8irq"
          }
        ],
        mandatory: false,
      },
      {
        id: "advertising",
        name: "Advertising",
        description: "We don't advertise on TrueDating.co.uk, but we use advertising cookies to help us measure the effectiveness of our advertising campaigns.",
        scripts: [
          {
            id: "adwords",
            src: "https://www.googletagmanager.com/gtag/js?id=AW-672747921",
            async: true,
          },
          {
            "id": "gtm-init",
            code: `
              gtag('consent', 'update', {
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'ad_storage': 'granted',
              });
            `
          },
        ],
        mandatory: false,
      }
    ],
  };
  return (
    <ConsentProvider options={consentOptions}>
      <ConsentBanner
        decline={{ hidden: false, label: "Reject Optionals" }}
        approve={{ hidden: false, label: "Accept" }}
        settings={{
          modal: {
            title: "Privacy Preference Center",
            description:
              "TrueDating.co.uk uses cookies to ensure our website works, to understand how you use our services, and to keep you logged in.",
            decline: {
              hidden: false,
              label: "Reject Optionals",
            },
            approve: { hidden: false, label: "Save My Preferences" },
            approveAll: { hidden: false, label: "Accept All" },

          },
        }}
      >
        <b>We use cookies to enhance your experience on this website</b>
        <p style={{fontSize: "0.8em" } }>
          TrueDataing.co.uk uses cookies to ensure our website works, to understand
          how you use our services, and to keep you logged in.
        </p>
      </ConsentBanner>
    </ConsentProvider>
  )
}
export default Consent;